import React from "react"
import { SubtitleProps, Subtitle } from "@citydna/common"
import { Divider, Box, makeStyles, Theme } from "@material-ui/core"
import { useSetHeight } from "./HeightProvider"

interface SidebarHeaderProps extends SubtitleProps {
  left?: React.ReactNode
  right?: React.ReactNode
}

/** Scoped @material-ui/core stylesheet */
const useStyles = makeStyles<Theme>(theme => ({
  subtitle: {
    "& .MuiTypography-root": {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
  },
}))

export const SidebarHeader: React.FC<SidebarHeaderProps> = ({
  loading,
  primary,
  secondary,
  left,
  right,
  children,
  ...props
}) => {
  /** Track height and send it to the heights provider */
  const ref = useSetHeight("sidebarHeader")

  /** Get scoped CSS classes */
  const classes = useStyles()

  return (
    <Box
      className="refHolder"
      // @ts-ignore
      ref={ref}
    >
      <Box p={2} display="flex" alignItems="center" {...props}>
        {left}
        <Subtitle
          primary={primary}
          secondary={secondary}
          loading={loading}
          flexGrow={1}
          minWidth={0}
          className={classes.subtitle}
        />
        {right}
      </Box>
      {children}
      <Divider />
    </Box>
  )
}
